import request from "./request";

//文件成事概要信息的列表
export const filePlaceholder = (params: any,) => {
    return request('put', `/api/placeholder/file_placeholder`, params)
}
//接入点目录查询
export const endpointId = (id: any) => {
    return request('get', `/api/placeholder/endpoint/${id}/dir`)
}
//接入点查询
export const endpoint = (params?: any) => {
    return request('get', `/api/placeholder/endpoint`, params)
}
// 
export const  filePlaceholderFavourites = (id: any, params?: any) => {
    return request('put', `/api/placeholder/file_placeholder/${id}/favorites`, params)
}

// 
export const  filePlaceholderById = (id: any) => {
    return request('get', `/api/placeholder/file_placeholder/${id}`)
}

// 
export const  filePlaceholderSimilarity = (id: any) => {
    return request('get', `/api/placeholder/file_placeholder/${id}/image/similarity`)
}
// 
export const  filePlaceholderThumbnail = (fileId: any, level?: any) => {
    return request('get', `/api/placeholder/file_placeholder/${fileId}/thumbnail/${level}`)
}

// 
export const filePlaceholderThumbnailLevel = (level?: number, param?: any) => {
    return request('put', `/api/placeholder/file_placeholder/thumbnails/${level}`, param);
}

// 
export const  filePlaceholderMimeType = (mime_type: any) => {
    return request('get', `/api/placeholder/file_placeholder/${mime_type}`)
}
//接入点远程目录查询
export const endpointRemoteDir = (params?: any) => {
    const {id,data} = params
    return request('get', `/api/placeholder/endpoint/${id}/remote/dir`, data)
}
//接入点同步目录设置
export const putEndpointDir = (params?: any) => {
    const {id,data} = params
    return request('put', `/api/placeholder/endpoint/${id}/dir`, data)
}

//接入点目录删除
export const delEndpointDir = (id: any,dirId:any) => {
    return request('delete', `/api/placeholder/endpoint/${id}/dir/${dirId}`)
}
//接入点目录开始同步
export const endpointRunning = (id: any,params:any) => {
    return request('post', `/api/placeholder/endpoint/${id}/dir/running/sync_status`,params)
}
//修改层级关系接口
export const updateTopicParent = (id: any,parentId?:any) => {
    return request('put', `/api/excelling/topic/updateTopicParent/${id}/${parentId||''}`)
}

